import DateFnsUtils from "@date-io/date-fns"
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import es from "date-fns/locale/es"
import moment from "moment"

export function FIELDS(data, handleChange, edit) {
  const formatedDate = data.fecha_creacion.split("/").reverse().join("-")
  const formatedDateF = data?.fecha_finalizacion?.split("/").reverse().join("-")
  return [
    {
      name: "dominio",
      label: "Dominio",
      class: "textfield",
      value: data.dominio,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      name: "marca",
      label: "Marca",
      class: "textfield",
      value: data.marca,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      name: "modelo",
      label: "Modelo",
      class: "textfield",
      value: data.modelo,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      name: "motor_nro",
      label: "Nº de motor",
      class: "textfield",
      value: data.motor_nro,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      name: "chasis_nro",
      label: "Nº de chasis",
      class: "textfield",
      value: data.chasis_nro,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      name: "estado",
      label: "Estado",
      class: "textfield",
      value: data.estado,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      name: "usuario_controlador",
      label: "Usuario controlador",
      class: "textfield",
      value: data.usuario_controlador,
      sm: 6,
      xs: 12,
      disabled: true,
    },
    {
      class: "custom",
      component: (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
          <KeyboardDatePicker
            key="fecha_creacion"
            autoOk
            variant="inline"
            inputVariant="outlined"
            PopoverProps={{ style: { ...{ left: "40px" } } }}
            fullWidth
            disabled={true}
            name="fecha_creacion"
            label="Fecha de carga"
            format="dd/MM/yyyy"
            value={data.fecha_creacion ? moment(formatedDate).local() : null}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </MuiPickersUtilsProvider>
      ),
      sm: 6,
      xs: 12,
    },
    {
      class: "custom",
      component: (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
          <KeyboardDatePicker
            key="fecha_finalizacion"
            autoOk
            variant="inline"
            inputVariant="outlined"
            PopoverProps={{ style: { ...{ left: "40px" } } }}
            fullWidth
            disabled={true}
            name="fecha_finalizacion"
            label="Fecha de finalización"
            format="dd/MM/yyyy"
            value={data.fecha_finalizacion ? moment(formatedDateF).local() : null}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </MuiPickersUtilsProvider>
      ),
      sm: 6,
      xs: 12,
    },
    {
      name: "observacion",
      label: "Observación",
      class: "textfield",
      value: data.observacion,
      sm: 6,
      xs: 12,
      onChange: (e) => {
        handleChange("observacion", e.target.value)
      },
      disabled: !edit,
    },
  ]
}